import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import PaginatedMenuView from '@/views/paginated_menu_view';
import template from '@/../templates/breadcrumb-item.hbs';

var globalCh = Radio.channel('global');

var v5_Object_Dropdown = PaginatedMenuView.extend( {
    className: 'ei-breadcrumb-content',
    template: Handlebars.compile(template),
    initialize: function() {
        var account = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        PaginatedMenuView.prototype.initialize.apply(this, arguments);
        this.on('select', this.change);

        this.model = this.getOption('active');

        switch ( this.model.type) {
            case 'development_devicegroup':
                if ( account.permits(primary, 'view_development_devicegroups') ) {
                    this.collection.add( { id: 'view_all_development_devicegroups', name: 'View All Development Device Groups' } );
                }
                break;
            // case applies to both the test factory and test production groups inside the test zone.
            case 'pre_factoryfixture_devicegroup':
            case 'pre_production_devicegroup':
            case 'pre_dut_devicegroup':
                if ( account.permits(primary, 'view_pre_production_devicegroups') ) {
                    this.collection.add( { id: 'view_all_pre_production_devicegroups', name:  'View All Test Production Device Groups'} );
                }
                if ( account.permits(primary, 'view_pre_factoryfixture_devicegroups') ) {
                    this.collection.add( { id: 'view_all_pre_dut_devicegroups', name: 'View All Test DUT Device Groups' } );
                    this.collection.add( { id: 'view_all_pre_factoryfixture_devicegroups', name: 'View All Test Fixture Device Groups' } );
                }
                break;
            case 'factoryfixture_devicegroup':
            case 'production_devicegroup':
            case 'dut_devicegroup':
                if ( account.permits(primary, 'view_production_devicegroups') ) {
                    this.collection.add( { id: 'view_all_production_devicegroups', name: 'View All Production Device Groups' } );
                }
                if ( account.permits(primary, 'view_factory_devicegroups') ) {
                    this.collection.add( { id: 'view_all_dut_devicegroups', name:  'View All DUT Device Groups'} );
                    this.collection.add( { id: 'view_all_factoryfixture_devicegroups', name:  'View All Fixture Device Groups'} );
                }
                break;
            default:
                console.warn('Unknown object type');
        }
    },
    change: function(v5_object) {
        if ( !v5_object ) v5_object = this.model;

        switch ( v5_object.id ) {
            case 'view_all_development_devicegroups':
                this.show_all_devicegroups('development_devicegroup');
                break;
            case 'view_all_pre_factoryfixture_devicegroups':
                this.show_all_devicegroups('pre_factoryfixture_devicegroup');
                break;
            case 'view_all_pre_production_devicegroups':
                this.show_all_devicegroups('pre_production_devicegroup');
                break;
            case 'view_all_production_devicegroups':
                this.show_all_devicegroups('production_devicegroup');
                break;
            case 'view_all_factoryfixture_devicegroups':
                this.show_all_devicegroups('factoryfixture_devicegroup');
                break;
            case 'view_all_pre_dut_devicegroups':
                this.show_all_devicegroups('pre_dut_devicegroup');
                break;
            case 'view_all_dut_devicegroups':
                this.show_all_devicegroups('dut_devicegroups');
                break;
            default:
                globalCh.request('set_selection', {
                    type: v5_object.type,
                    id: v5_object.id,
                    v5_object: v5_object
                });
                this.menu_action(v5_object);
        }
    },
    set_active: function(active_v5_object) {
        this.model = active_v5_object;
    },
    onRender: function() {
        const product = this.model.rel.get('product');
        this.set_menu_title(this.model.get('name'));
        this.children.each(function (child) {
            if (child.model.get('id') === this.model.id) {
                child.$('a').addClass('active');
            } else {
                child.$('a').removeClass('active');
            }
            if (child.el.dataset.id && child.el.dataset.id.indexOf('view_all') > -1 ) {
                child.$el.find('a').addClass('view-all');
                let url = `/ide/products/${product.id}/devicegroups/`;
                switch ( child.el.dataset.id ) {
                    case 'view_all_development_devicegroups':
                        url = url + 'development';
                        break;
                    case 'view_all_pre_factoryfixture_devicegroups':
                        url = url + 'test_factory';
                        break;
                    case 'view_all_pre_production_devicegroups':
                        url = url + 'test_production';
                        break;
                    case 'view_all_production_devicegroups':
                        url = url + 'production';
                        break;
                    case 'view_all_factoryfixture_devicegroups':
                        url = url + 'factory';
                        break;
                    case 'view_all_pre_dut_devicegroups':
                        url = url + 'test_dut';
                        break;
                    case 'view_all_dut_devicegroups':
                        url = url + 'dut';
                        break;
                }
                child.$el.find('a').attr('href', url);
            }
        }.bind(this));
        this.set_menu_info(this.model.type_readable());
    },
    menu_action: function(v5_object) {
        v5_object.bandwidth.fetch_day(null, new Date(), 'days').then( function(){
            globalCh.request('show_devicegroup_dashboard', v5_object);
        });
    },
    show_all_devicegroups: function(devicegroup_type){
        devicegroup_type = devicegroup_type || 'development_devicegroup';
        var product = this.model.rel.get('product');
        switch ( devicegroup_type ){
            case 'pre_factoryfixture_devicegroup':
                globalCh.request('show_pre_factoryfixture_devicegroups', product);
                return;
            case 'pre_production_devicegroup':
                globalCh.request('show_pre_production_devicegroups', product);
                return;
            case 'factoryfixture_devicegroup':
                globalCh.request('show_factory_devicegroups', product);
                return;
            case 'production_devicegroup':
                globalCh.request('show_production_devicegroups', product);
                return;
            case 'pre_dut_devicegroup':
                globalCh.request('show_pre_dut_devicegroups', product);
                return;
            case 'dut_devicegroups':
                globalCh.request('show_dut_devicegroups', product);
                return;
            default: {
                globalCh.request('show_development_devicegroups', product, devicegroup_type);
            }
        }
    }
});

export default v5_Object_Dropdown;
